import styled from '@emotion/styled'
import { SkeletonPulse, radius, space } from '@ticketswap/solar'
import { generateSkeletons } from '~/utils/generateSkeletons'

const StyledSkeletonPulse = styled(SkeletonPulse)`
  display: block;
  border-radius: ${radius.lg};
  height: ${space[256]};
`

interface Props {
  count?: number
}

export const Skeleton = ({ count = 1 }: Props) => (
  <>
    {generateSkeletons(
      <div>
        <StyledSkeletonPulse />
      </div>,
      count
    )}
  </>
)
